import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";
import classNames from "classnames";

import { useHelpEmail } from "../stateHooks";

NonHeadOfHousehold.propTypes = {
  isMobile: PropTypes.bool,
};

export default function NonHeadOfHousehold({ isMobile }) {
  const {
    state: { user },
  } = useManageMyGivingPage();
  const helpEmail = useHelpEmail();

  // This is a final sanity check.
  // There are times that state.userID is populated, but not the user object.
  // We need to make sure the user object ID is populated as well, so that we can trust the isHoH flag.
  const shouldDisplay = user?.ID && !user?.isHoHOrSpouseOfHoH;

  if (!shouldDisplay) {
    return null;
  }

  return (
    <OuterWrapper className={classNames({ mobile: isMobile })}>
      <Wrapper>
        <Main>
          <div>
            <Title>Head of Household</Title>

            <Message>
              <p>
                It looks like you are part of an existing Flocknote household,
                but not designated as a Head of Household.
              </p>
              <p>
                To view and manage household giving, please have a Head of
                Household log in, contact an admin, or email{" "}
                <a
                  href={`mailto:${helpEmail}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {helpEmail}
                </a>{" "}
                for assistance.
              </p>
            </Message>
          </div>
        </Main>
      </Wrapper>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  &.mobile {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    @media (max-width: 1000px) {
      display: flex;
    }
  }
`;

const Wrapper = styled.div`
  padding: 0 20px;
  color: var(--textPrimary);

  ${OuterWrapper}.mobile & {
    color: white;
    border-radius: 24px;
    background: linear-gradient(
      140deg,
      var(--bgGradient1) 0%,
      var(--bgGradient2) 100%
    );
  }
`;

const Main = styled.main`
  margin-top: 12px;
  display: flex;
  gap: 30px;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

const Title = styled.h1`
  font-weight: 600;

  @media (max-width: 640px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const Message = styled.div`
  margin-top: 16px;
  font-weight: 400;

  @media (max-width: 640px) {
    text-align: center;
  }
`;
